module.exports = __webpack_public_path__ + "img/trial4-1.87a7d620.png";